// extracted by mini-css-extract-plugin
export default {"primary":"primary_button-module__primary--SJdkJ"};